import { IPurchaseOrderService } from './IPurchaseOrderService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, PREVILEGEKEY, TransactionType } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PurchaseOrderEntity, PurchaseOrderPostEntity } from '../../../models/PurchaseOrder/PurchaseOrderEntity';
import { PurchaseOrderHeaderEntity } from '../../../models/PurchaseOrder/PurchaseOrderHeaderEntity';
import { ValidationEntity } from '../../../models/Utilities/ValidationEntity';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService implements IPurchaseOrderService {
  constructor(private httpService: HttpRequestService) { }

  GetPOSummary(siteId: number, transType: number, menuId: number, userId: number,
               searchText: string = ''): Observable<PurchaseOrderHeaderEntity[]> {
    let inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('transType', transType.toString())
      .set('menuId', menuId.toString())
      .set('userId', userId.toString())
      .set('APIKEY', PREVILEGEKEY.GetPOSummary);
    if (searchText !== '') {
        inputParams = inputParams.append('searchValue', searchText.toString());
      }
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PurchaseOrderAPI.GetPOSummary);
  }
  GetPODetail(PONumber: number, siteId: number): Observable<PurchaseOrderEntity> {
    const inputParams = new HttpParams().set('PONumber', PONumber.toString()).set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PurchaseOrderAPI.GetPODetail);
  }
  GetApprovedRQASummary(siteId: number): Observable<PurchaseOrderHeaderEntity[]> {
    const inputParams = new HttpParams().set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PurchaseOrderAPI.GetApprovedRQASummary);
  }
  GetApprovedRQADetail(rqaHeaderId: number, userId: number, siteId: number): Observable<PurchaseOrderEntity> {
    const inputParams = new HttpParams()
    .set('rqaHeaderId', rqaHeaderId.toString()).set('userId', userId.toString()).set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PurchaseOrderAPI.GetApprovedRQADetail);
  }
  PostPurchaseOrder(entity: PurchaseOrderEntity): Observable<ValidationEntity> {
    return this.httpService.postHttpRequest(apiURLs.PurchaseOrderAPI.SavePurchaseOrder, entity);
  }
  PurchaseOrderPost(entity: PurchaseOrderPostEntity): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.PostPurchaseOrder, entity);
  }
  AutoSavePurchaseOrderPost(entity: PurchaseOrderPostEntity): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.AutoSavePostPurchaseOrder, entity);
  }
  IsPOExist(supplierId: number, postDate: Date, locationId: number, eatecEntity: number = 1): Observable<number> {
    const inputParams = new HttpParams().set('supplierId', supplierId.toString())
      .set('postDate', postDate.toString())
      .set('locationId', locationId.toString())
      .set('eatecEntity', eatecEntity.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PurchaseOrderAPI.IsPOExist);
  }
  GetPOExport(siteId: number, supplierId: number, changeAllowed: boolean = false): Observable<number> {
    const inputParams = new HttpParams().set('siteId', siteId.toString())
      .set('supplierId', supplierId.toString())
      .set('changeAllowed', changeAllowed.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.PurchaseOrderAPI.GetPOExport);
  }
   /**
   * @version 13.2 UI Modification
   * @param PurchaseOrderHeadParams
   * @returns
   */
  GetPurchaseOrderHead(PurchaseOrderHeadParams: any): Observable<any> {
    const purchaseorderRequestUrl = apiURLs.TransactionManagement.GetPurchaseOrderHeadSummary + PurchaseOrderHeadParams;
    return this.httpService.GetHttpRequest(purchaseorderRequestUrl);
  }

   /**
   * @version 24.3
   * @param requestParams
   * @returns
   */
   GetAllPurchaseOrder(requestParams: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetAllPurchaseOrder, requestParams);    
  }
   GetAllSavedPO(requestParams: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetAllSavedPO, requestParams);    
  }
  GetPurchaseReqHead(PurchaseOrderHeadParams: any): Observable<any> {
    const purchaseorderRequestUrl = apiURLs.TransactionManagement.GetPurchaseReqHead + PurchaseOrderHeadParams;
    return this.httpService.GetHttpRequest(purchaseorderRequestUrl);
  }

  GetAllPurchaseRequest(PurchaseOrderHeadParams: any): Observable<any> {
    const purchaseorderRequestUrl = apiURLs.TransactionManagement.GetAllPurchaseRequest;
    return this.httpService.postHttpRequest(purchaseorderRequestUrl, PurchaseOrderHeadParams);
  }
    GetInventoryLocations(LocationParams: any): Observable<any> {
      const locationRequestUrl = apiURLs.InvertoryManagement.GetInventoryLocation + LocationParams;
      return this.httpService.GetHttpRequest(locationRequestUrl);
    }
    /**
  * @version 25.2 UI Modification
  * @returns 
  */
    GetMasterData(EndPointUrl): Observable<any> {
      return this.httpService.GetHttpRequest(EndPointUrl);
    }
    GetSupplierSearch(): Observable<any> {
      const supplierRequestUrl = apiURLs.TransactionManagement.GetSuppliersSearchDetails;
      return this.httpService.GetHttpRequest(supplierRequestUrl);
    }
    GetPurchaseOrderDetails(PurchaseDetailsParams: any): Observable<any> {
      const purchaseorderdetailRequestUrl = apiURLs.TransactionManagement.GetPurchaseOrderDetail + PurchaseDetailsParams;
      return this.httpService.GetHttpRequest(purchaseorderdetailRequestUrl);
    }
    GetPurchaseOrderHeadandDetails(poHeaderId: number, transTypeId: number): Observable<any> {
      const reqHeadUrl = `${apiURLs.TransactionManagement.GetPurchaseOrderById}` + `?transId=${poHeaderId}&` + `TransTypeId=${transTypeId}`;
      return this.httpService.GetHttpRequest(reqHeadUrl);
    }
    GetSavedPOById(poHeaderId: number, transTypeId: number): Observable<any> {
      const reqHeadUrl = `${apiURLs.TransactionManagement.GetSavedPOById}` + `?transId=${poHeaderId}&` + `TransTypeId=${transTypeId}`;
      return this.httpService.GetHttpRequest(reqHeadUrl);
    }
    GetPurchaseReqById(poHeaderId: number, transTypeId: number): Observable<any> {
      const reqHeadUrl = `${apiURLs.TransactionManagement.GetPurchaseReqById}` + `?transId=${poHeaderId}&` + `TransTypeId=${transTypeId}`;
      return this.httpService.GetHttpRequest(reqHeadUrl);
    }
    GetPurchaseReqHeadDetails(poHeaderId: number, transTypeId: number): Observable<any> {
      const reqHeadUrl = `${apiURLs.TransactionManagement.GetPurchaseReqHead}/` + poHeaderId + `?transtype=${transTypeId}`;
      return this.httpService.GetHttpRequest(reqHeadUrl);
    }
    PurchaseOrderPut(entity: PurchaseOrderPostEntity, poId: any): Observable<any> {
      const reqHeadUrl = `${apiURLs.TransactionManagement.PostPurchaseOrder}/` +  poId;
      return this.httpService.postHttpRequest(reqHeadUrl, entity);
    }
    PurchaseOrderCancel(poId: string, sendMailToSupplier = false): Observable<any> {
      let reqHeadUrl = `${apiURLs.TransactionManagement.GetPurchaseOrderHeadSummary}/'` +  poId + `'`;
      if (sendMailToSupplier) {
        reqHeadUrl = `${apiURLs.TransactionManagement.GetPurchaseOrderHeadSummary}?key=` +  poId + `&isResendPOEmail=true`;
      }      
      return this.httpService.deleteHttpRequest(reqHeadUrl);
    }
    SavedPOCancel(poId: number[]): Observable<any> {
      return this.httpService.postHttpRequest(apiURLs.TransactionManagement.DiscardSavedPO, poId);
    }
    GetSuppliers(requestQuery): Observable<any> {
      const supplierRequestUrl = apiURLs.TransactionManagement.GetSuppliersSearchDetails + requestQuery;
      return this.httpService.GetHttpRequest(supplierRequestUrl);
    }
    GetV2Suppliers(inputString, locationId): Observable<any> {
      let requestParams:any = {};
      requestParams["SearchText"] = inputString;
      requestParams["FromLocationId"] = locationId;
      return this.httpService.postHttpRequest(apiURLs.InventoryAPI.GetV2Suppliers, requestParams);
    }

    GetSupplierDetailForRecieving(supplierId: number, locationId: number): Observable<any> {
      const reqHeadUrl = `${apiURLs.InventoryAPI.GetSupplierDetailForRecieving}` + `?supplierId=${supplierId}&locationId=${locationId}`;
      return this.httpService.GetHttpRequest(reqHeadUrl);
    }

    GetInvoiceAutomationDetails(ersId: number): Observable<any> {
      const reqHeadUrl = `${apiURLs.TransactionManagement.GetERSInvoiceById}` + `?ersId=${ersId}`;
      return this.httpService.GetHttpRequest(reqHeadUrl);
    }

    SendMailToSupplier(purchaseOrderIds: string): Observable<any> {
      const endpoint = `${apiURLs.TransactionManagement.SendMailToSupplier}/${TransactionType.PurchaseOrder}/${purchaseOrderIds}`;
      return this.httpService.GetHttpRequest(endpoint);
    }
}
